import React, { useState} from "react";
import { supabase } from "../supabaseClient";

export default function ForgotPassword() {
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	async function handleReset(e) {
		e.preventDefault();
		setError("");
		setMessage("");
		setLoading(true);
		
		const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
			redirectTo: "http://localhost:3000/reset-password",
		});
		console.log("Reset email data sent:", data);
		console.log("Reset email error sent:", error);
		setLoading(false);
		if (error) setError(error.message);
		else setMessage("Password reset email sent! (Check your spam folder.)");
	}

	return (
		<form onSubmit={handleReset} className="font-sans space-y-3 mt-6 max-w-sm mx-auto">
			<h3 className="text-md font-bold">Forgot Password?</h3>
			<input
				type="email"
				className="w-full px-3 py-2 text-gray-900 placeholder-gray-700 border border-gray-300 rounded-xl focus:outline-none"
				value={email}
				onChange={(e) => setEmail(e.target.value)}
				placeholder="Your account email"
				required
			/>
			<button className="bg-zinc-50 text-black hover:bg-zinc-200 transition border border-neutral-300 hover:border-neutral-400 px-3 py-2 rounded-xl w-full" type="submit" disabled={loading}>
				{loading ? "Sending..." : "Send Reset Email"}
			</button>
			{error && <div className="text-red-500">{error}</div>}
			{message && <div className="text-green-600">{message}</div>}
		</form>
	);
}
